import { useContext, useEffect, useState } from "react";
import CadastrarEmpresas from './CadastrarEmpresas';
import EmpressasCadastradas from './EmpresasCadastradas';
import { Box, Stack, Tab, Tabs, Typography } from "@mui/material";
import ApartmentIcon from '@mui/icons-material/Apartment';
import DomainAddIcon from '@mui/icons-material/DomainAdd';
import KeyIcon from '@mui/icons-material/Key';
import { EmpresasContext } from "../../context/EmpresasContext";
import AbasAcessos from "./AbasAcessos";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}


function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;



  return (
    <div
      style={{ width: '100%' }}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export default function EmpresasComponent() {
  const { refetch } = useContext(EmpresasContext);

  useEffect(() => {
    refetch();
  }, [refetch]);

  const [value, setValue] = useState<number>(0);
  function handleChange(event: React.SyntheticEvent, newValue: number) {
    setValue(newValue);
  };

  return (
    <Stack direction='column' alignItems='flex-start' justifyContent='flex-start' width='100%' spacing={2}>
      <Typography variant='h5' fontWeight={600} color='textDisabled' textAlign='center' width='100%' >Gestão de empresas</Typography>
      <Tabs
        value={value}
        onChange={handleChange}
        indicatorColor='secondary'
        textColor='secondary'
        variant="scrollable"
        scrollButtons="auto"
      >
        <Tab iconPosition="end" icon={<ApartmentIcon />} label='Empresas cadastradas' value={0} />
        <Tab iconPosition="end" icon={<DomainAddIcon />} label='Criar empresa' value={1} />
        <Tab iconPosition="end" icon={<KeyIcon />} label='Acessos' value={2} />
      </Tabs>
      <CustomTabPanel value={value} index={0}>
        <EmpressasCadastradas />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <CadastrarEmpresas />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <AbasAcessos />
      </CustomTabPanel>
    </Stack>
  );
}